import { graphql } from '@/gql';
import type { CancelGroceryMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const cancelGrocery = async ({ orderId, reason, cancelType }: CancelGroceryMutationVariables): Promise<boolean> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation cancelGrocery($orderId: String!, $reason: String!, $cancelType: Float!) {
        cancelGrocery(orderId: $orderId, reason: $reason, cancelType: $cancelType) {
          id
          status
        }
      }
    `),
    variables: {
      orderId,
      reason,
      cancelType,
    },
  });

  return !!response.data?.cancelGrocery;
};
